// Styled version of LoadingIndicator

import styled, { keyframes } from "styled-components";

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #f3f4f5;
  border-radius: 50%;
  width: ${(props) => {
    switch (props.size) {
      case "small":
        return "24px";
      case "large":
        return "64px";
      default:
        return "40px";
    }
  }};
  height: ${(props) => {
    switch (props.size) {
      case "small":
        return "24px";
      case "large":
        return "64px";
      default:
        return "40px";
    }
  }};
  animation: ${spin} 1s linear infinite;
`;

export const StyledLoadingIndicator = ({ size = "medium" }) => {
  return (
    <LoadingContainer>
      <Spinner size={size} />
    </LoadingContainer>
  );
};

export default StyledLoadingIndicator;
